import Skeleton from "react-loading-skeleton"

const PricingSkeleton: React.FC = () => {
    return (
        <div className="d-flex flex-column align-items-center">
            <div className="w-75">
                <Skeleton height={40} className="w-100" />
            </div>
            <div className="w-75 mt-2">
                <Skeleton height={20} className="w-100" />
            </div>
            <div className="d-flex justify-content-center mt-2 content" style={{ width: "90%" }}>
                <div className="w-100">
                    <Skeleton height={40} className="w-100" style={{ borderTopLeftRadius: '10px', borderBottomLeftRadius: '10px' }} />
                </div>
                <div className="w-100">
                    <Skeleton height={40} className="w-100" />
                </div>
                <div className="w-100">
                    <Skeleton height={40} className="w-100" style={{ borderTopRightRadius: '10px', borderBottomRightRadius: '10px' }} />
                </div>
            </div>
            {
                Array.from({ length: 2 }).map((_, i) => {
                    return (
                        <div key={i} className="card card-style py-2 position-relative" style={{width: '90%'}}>
                            <div className="content">
                                <div className="d-flex justify-content-start align-items-center">
                                    <h1 className="text-center">
                                        <Skeleton height={65} width={70} />
                                    </h1>
                                </div>
                                <div className="d-flex justify-content-start align-items-center">
                                    <h4 className="text-center">
                                        <Skeleton height={30} width={100} />
                                    </h4>
                                </div>
                                <div className="d-flex justify-content-start align-items-center">
                                    <p className="text-center">
                                        <Skeleton height={15} width={200} />
                                    </p>
                                </div>
                                <div className="divider mt-4"></div>
                                <div className="table-responsive px-3 ">
                                    <table className="table align-middle table-row-dashed o">
                                        <thead>
                                            <tr className="border-bottom">
                                                <th><Skeleton height={20} className="w-100" /></th>
                                                <th className="text-end"><Skeleton height={20} className="w-75" /></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                Array.from({ length: 4 }).map((_, i) => {
                                                    return (
                                                        <tr key={i}>
                                                            <td>
                                                                <Skeleton height={20} className="w-100" />
                                                            </td>
                                                            <td className="text-end">
                                                                <Skeleton height={20} className="w-25" />
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <Skeleton height={40} className="btn btn-sm w-100 rounded-4" />
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default PricingSkeleton